import { render } from "./EdicionArticulo.vue?vue&type=template&id=4f85ff4c&scoped=true"
import script from "./EdicionArticulo.vue?vue&type=script&lang=js"
export * from "./EdicionArticulo.vue?vue&type=script&lang=js"

import "./EdicionArticulo.vue?vue&type=style&index=0&id=4f85ff4c&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f85ff4c"]])

export default __exports__